<template>
	<div>
		<v-row>
			<v-col xs="12" md="12" lg="6" v-for="item in statistic" :key="item.title">
				<div
					class="pa-4 d-flex align-center has-border full-height"
					style="background-color:#f8f8f8;"
				>
					<v-icon color="primary" class="mr-3">{{ item.image }}</v-icon>
					<div>
						<div>{{ item.title }}</div>
						<div class="d-inline-flex align-end">
							<div class="text-h5 font-weight-medium">
								{{ item.number }}
							</div>
							<div v-if="item.type === 'income'" class=" ml-1 caption">
								VNĐ
							</div>
						</div>
					</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
export default {
	props: {
		totalBillsInMonth: {
			type: Number,
			default: 0
		},
		income: {
			type: Number,
			default: 0
		}
	},
	computed: {
		statistic() {
			return [
				{
					type: 'totalBill',
					number: this.totalBillsInMonth.toLocaleString(),
					title: this.$vuetify.lang.t(
						'$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_BILL_QUANTITY'
					),
					image: 'mdi-cart'
				},
				{
					number: Number(this.income.toFixed(0)).toLocaleString(),
					title: this.$vuetify.lang.t(
						'$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_REVENUE'
					),
					image: 'mdi-currency-usd'
				}
			]
		}
	}
}
</script>
